import React, { FormEvent, useEffect, useState } from 'react';
import { createEntreprise, getEntreprises, updateEntreprise } from '../../services/entreprisesAPI';

type Entreprise = {
  id: number; nom: string; email?: string; telephone?: string; adresse?: string;
  actif: boolean; date_creation?: string; nombre_utilisateurs?: number;
  administrateurPrincipal?: { prenom: string; nom: string };
};

const emptyForm = { nom: '', email: '', telephone: '', adresse: '' };

const EntreprisesTab: React.FC = () => {
  const [entreprises, setEntreprises] = useState<Entreprise[]>([]);
  const [form, setForm] = useState(emptyForm);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try { setLoading(true); setEntreprises((await getEntreprises()).data || []); setError(''); }
    catch (e: any) { setError(e.message); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    try { await createEntreprise(form); setForm(emptyForm); await load(); }
    catch (e: any) { setError(e.message); }
  };
  const toggle = async (entreprise: Entreprise) => {
    try { await updateEntreprise(entreprise.id, { actif: !entreprise.actif }); await load(); }
    catch (e: any) { setError(e.message); }
  };

  return <div className="companies-module">
    <div className="companies-heading">
      <div className="companies-heading-icon">🏢</div>
      <div>
        <h3>Gestion des entreprises</h3>
        <p>Créez vos entreprises et attribuez ensuite chaque utilisateur à l’entreprise appropriée.</p>
      </div>
    </div>
    {error && <div className="error-message">{error}</div>}
    <form onSubmit={submit} className="companies-form">
      <label><span>Nom de l’entreprise *</span><input required placeholder="Ex. Immigreat Nord" value={form.nom} onChange={(e) => setForm({ ...form, nom: e.target.value })} /></label>
      <label><span>Courriel</span><input type="email" placeholder="contact@entreprise.ma" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></label>
      <label><span>Téléphone</span><input placeholder="+212 …" value={form.telephone} onChange={(e) => setForm({ ...form, telephone: e.target.value })} /></label>
      <label><span>Adresse</span><input placeholder="Ville, pays" value={form.adresse} onChange={(e) => setForm({ ...form, adresse: e.target.value })} /></label>
      <button className="companies-create-button" type="submit">+ Créer l’entreprise</button>
    </form>
    {loading ? <p className="companies-loading">Chargement…</p> : <div className="companies-table-wrap"><table className="companies-table"><thead><tr><th>Entreprise</th><th>Administrateur</th><th>Utilisateurs</th><th>Statut</th><th>Création</th><th></th></tr></thead><tbody>
      {entreprises.map((entreprise) => <tr key={entreprise.id}><td className="company-name">{entreprise.nom}</td><td>{entreprise.administrateurPrincipal ? `${entreprise.administrateurPrincipal.prenom} ${entreprise.administrateurPrincipal.nom}` : <span className="company-muted">À définir</span>}</td><td><span className="company-count">{entreprise.nombre_utilisateurs || 0}</span></td><td><span className={`company-status ${entreprise.actif ? 'is-active' : 'is-inactive'}`}>{entreprise.actif ? 'Actif' : 'Inactif'}</span></td><td>{entreprise.date_creation ? new Date(entreprise.date_creation).toLocaleDateString('fr-FR') : '-'}</td><td><button className="company-toggle" onClick={() => toggle(entreprise)}>{entreprise.actif ? 'Désactiver' : 'Activer'}</button></td></tr>)}
    </tbody></table></div>}
  </div>;
};

export default EntreprisesTab;
